export class UpravnoPodrucje {
  key: number;
  label: string;
  children: UpravniPosao[];
  selectable: boolean;
  constructor(id: number, naziv: string, poslovi: UpravniPosao[] = []) {
    this.key = id;
    this.label = naziv;
    this.children = poslovi;
    this.selectable = false;
  }
}

export class UpravniPosao {
  key: number;
  label: string;
  children: UpravnaStvar[];
  selectable: boolean;
  constructor(id: number, naziv: string, stvari: UpravnaStvar[] = []) {
    this.key = id;
    this.label = naziv;
    this.children = stvari;
    this.selectable = false;
  }
}

export class UpravnaStvar {
  key: number;
  label: string;
  selectable: boolean;
  constructor(id: number, naziv: string) {
    this.key = id;
    this.label = naziv;
    this.selectable = true;
  }
}
